// extracted by mini-css-extract-plugin
export default {"content":"OpinionsForApprovalTable_content__AJ2Gx"};